<template>
  <v-app>
    <v-layout :style="{ backgroundImage: 'url('+require('@/assets/starrynight.jpg')+')'}" style="background-size: cover">
      <v-container>
        <v-layout align-center justify-center row class="mt-16">
          <v-card class="grey lighten-1" width="600px" style="opacity:80%">
            <v-card-title>
              Sign Up
            </v-card-title>
              <v-layout v-if="error">
                <error-alert @dismissed="onDismissed" :text="error.message"></error-alert>
              </v-layout>
            <v-form @submit.prevent="onSignUp">
              <v-text-field
                label="Enter your email address"
                class="mx-4"
                name="email"
                id="email"
                v-model="email"
                type="email"
              >
              </v-text-field>
              <v-text-field
                label="Enter your password"
                class="mx-4"
                name="password"
                id="password"
                v-model="password"
                :type="show ? 'text' : 'password'"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show = !show"
              >
              </v-text-field>
              <v-text-field
                label="Re-enter your password"
                class="mx-4"
                name="confirmedPassword"
                id="confirmedPassword"
                v-model="confirmedPassword"
                :type="show ? 'text' : 'password'"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show = !show"
                :rules="[comparePassword]"
              >
              </v-text-field>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-2"
                :disabled="button"
                type="submit"
                :loading="loading">
                <v-icon left>
                  mdi-account-plus
                </v-icon>
                Create account
              </v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-layout>
      </v-container>
    </v-layout>
  </v-app>
</template>

<script>
export default {
  title: 'Sign Up',
  data () {
    return {
      show: false,
      email: '',
      password: '',
      confirmedPassword: ''
    }
  },
  methods: {
    onSignUp () {
      this.$store.dispatch('signUserUp', { email: this.email, password: this.password })
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  },
  computed: {
    formIsValid () {
      return this.email !== '' &&
      this.password !== '' &&
      this.confirmedPassword !== ''
    },
    comparePassword () {
      return this.password !== this.confirmedPassword ? "Password doesn't match" : true
    },
    button () {
      return (this.password !== this.confirmedPassword || this.email === '' || this.password === '' || this.confirmedPassword === '')
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    }
  }
}
</script>
